import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material";
import { ConfirmPopUpFinzyFlexData } from "../confirm-pop-up-finzy-flex/confirm-pop-up-finzy-flex.component";

@Component({
    selector: 'app-confirmation-popup-with-svg',
    templateUrl: 'confirmation-popup-with-svg.component.html',
})
export class ConfirmationPopupWithSvgComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public popUpData: ConfirmPopUpFinzyFlexData
    ) {}
}